import React from "react";
import { Outlet } from "react-router-dom";
import { HeaderPortal } from "@/components/src/header-portal/header-portal.component";
import { DebitorenMenu } from "./components/debitoren-menu.component";
import { FeatureGateOverlay } from "../../components/subscription/feature-gate-overlay.component";

export const DebitorenPage: React.FC = () => {
	return (
		<FeatureGateOverlay>
			<HeaderPortal>
				<div className="flex items-center justify-between w-full gap-1">
					<DebitorenMenu />
				</div>
			</HeaderPortal>

			<div className="flex-1 overflow-hidden h-full">
				<div className="h-full overflow-auto">
					<Outlet />
				</div>
			</div>
		</FeatureGateOverlay>
	);
};
